import IntegrationItem from './integrationItem';

export default IntegrationItem;
